import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../config';
import { useAuth } from '../context/AuthContext';

import PublicHeader from '../components/Header/PublicHeader';
import PublicFooter from '../components/Footer/PublicFooter';
import Button from '../components/ui/Button';

import './Plans.css';

const Plans = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { user } = useAuth(); // ONLY used to decide CTA text
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const res = await fetch(`${API_BASE}/public/plans`);

        if (!res.ok) {
          throw new Error(`Failed to load plans`);
        }

        const data = await res.json();

        const plansList = Array.isArray(data)
          ? data
          : data?.plans || [];

        setPlans(plansList);
      } catch (err) {
        console.error('[Plans] fetch failed', err);
        setError('Unable to load plans');
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, []);

  const handleSelectPlan = (planName) => {
    /**
     * Public decision only.
     * Stripe is NOT called here.
     */
    if (!user) {
      navigate(`/login?plan=${planName}`);
    } else {
      navigate(`/checkout?plan=${planName}`);
    }
  };

  return (
    <>
      <PublicHeader />

      <section className="plans-page">
        <div className="container">
          <h1 className="plans-title">Choose a Plan</h1>
          <p className="plans-subtitle">
            Simple, transparent pricing designed to scale with your usage.
          </p>

          {loading && <div>Loading plans…</div>}
          {error && <div className="plans-error">{error}</div>}

          {!loading && !error && (
            <div className="plans-grid">
              {plans.map((plan) => (
                <div key={plan.name} className="plan-card">
                  <h3 className="plan-name">{plan.label}</h3>

                  <p className="plan-description">
                    {plan.description}
                  </p>

                  <div className="plan-price">
                    <span className="price">${plan.priceUsd}</span>
                    <span className="period">/ month</span>
                  </div>

                  <p className="plan-limit">
                    {plan.tokenLimit} tokens / month
                  </p>

                  <div className="plan-action">
                    <Button
                      variant="primary"
                      onClick={() => handleSelectPlan(plan.name)}
                    >
                      {user ? 'Subscribe' : 'Get Started'}
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <PublicFooter />
    </>
  );
};

export default Plans;
